module.exports = __webpack_public_path__ + "img/icon (13).2be5895f.png";